import { ErrorMessage, Form, Formik } from 'formik';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { useEffect, useRef, useState } from 'react';
import { msgTypes } from 'constants/msgTypes';
import { MemberBankDetailsModel } from 'model/screensModels/MemberBankDetailsModel';
import { MemberBankDetailsService } from 'services/menu/memberBankDetailsService/MemberBankDetailsService';
import { UtilService } from 'services/shared/UtilService';
import { MemberBankDetailsSchema } from 'schemas/menu/memberBankDetailsSchema/MemberBankDetailsSchema';
import { LocalStorageService } from 'services/auth/LocalStorageService';



const CreateMemberBank = ({ setFlag, updateRecord, loadRecentBankDetails }) => {
  const [companyList, setCompanyList] = useState([]);
  const [initialValue, setInitialValue] = useState(new MemberBankDetailsModel());
  const [countryList, setCountryList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const formikRef = useRef(null);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    loadCompany();
    getUserRole();
    getCurrencyList();

  }, [])

  useEffect(() => {
    loadCompany();
    loadCountry();
    if (updateRecord) {
      setInitialValue(updateRecord)
    }
  }, [updateRecord])

  useEffect(() => {
    if (userRole === msgTypes.USER_TYPE.MEMBER) {
      setCompanyId();
    }
  }, [userRole])

  const setCompanyId = async () => {
    //  If User is member then display company id in disable mode
    if (userRole === msgTypes.USER_TYPE.MEMBER) {
      const companyDetails = JSON.parse(await LocalStorageService.getUserDetails());
      const model = new MemberBankDetailsModel();
      model.companyId = companyDetails.companyId;
      setInitialValue(model)
    }
  }

  const getUserRole = async () => {
    const role = await LocalStorageService.getUserRole();
    setUserRole(role);
  }

  //load country
  const loadCountry = async () => {
    const res = await UtilService.getCountryList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCountryList(res.data);
    }
  };

  //load Currency
  const getCurrencyList = async () => {
    const res = await UtilService.getCurrencyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setCurrencyList(res.data);
    }
  };


  const loadCompany = async () => {
    const res = await UtilService.getCompanyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setCompanyList(res.data);
      } else {
        setCompanyList([]);
      }
    }
  }

  const onSubmit = async (values: MemberBankDetailsModel) => {
    addBankDetails(values)
  }

  //Prepare Data for API
  const prepareRequestBody = async (values: MemberBankDetailsModel) => {
    const prepareData = new MemberBankDetailsModel();

    //to assing id based on action 
    if ((initialValue.bankId)?.length > 0) {
      prepareData.bankId = initialValue.bankId;
    } else {
      prepareData.bankId = values.bankId ? values.bankId : '';
    }

    prepareData.companyId = values.companyId ? values.companyId : '';
    prepareData.accountHolderName = values.accountHolderName ? values.accountHolderName : '';
    prepareData.accountNumber = values.accountNumber ? values.accountNumber : '';
    prepareData.bankName = values.bankName ? values.bankName : '';
    prepareData.countryId = values.countryId ? values.countryId : '';
    prepareData.currency = values.currency ? values.currency : '';
    prepareData.branchName = values.branchName ? values.branchName : "";
    prepareData.swiftCode = values.swiftCode ? values.swiftCode : "";
    prepareData.iban = values.iban ? values.iban : "";
    prepareData.routingNo = values.routingNo ? values.routingNo : "";
    prepareData.type = values.type ? values.type : '';

    return prepareData;

  }

  const addBankDetails = async (values: MemberBankDetailsModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await MemberBankDetailsService.saveBankDetails(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValue(new MemberBankDetailsModel())
      if (userRole === msgTypes.USER_TYPE.ADMIN) {
        loadRecentBankDetails();
      }
      if (userRole === msgTypes.USER_TYPE.ADMIN) {
        formikRef.current.resetForm();
      } else {
        formikRef.current.resetForm();
        const model = new MemberBankDetailsModel()
        model.companyId = requestData.companyId;
        setInitialValue(model);
      }
    }
  }


  const formattedCurrencyList = currencyList.map(item => ({
    ...item,
    displayName: `${item.country} - ${item.currency}`,
  }));
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={MemberBankDetailsSchema}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {
          ({ isValid, dirty, isSubmitting, values, errors  }) => {
            return(
            <Form>
              <div className="container">
                <div className="row p-3">
                  <div className="col-md-6 position-relative">
                    <FormikControl
                      control="autocomplete"
                      name="companyId"
                      label="Company Name"
                      // placeholder="Select Debtor Company"
                      options={companyList}
                      keyfield="companyName"
                      valuefield="companyId"
                      disabled={userRole === msgTypes.USER_TYPE.MEMBER ? true : false}
                      requiredField
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='textfield'
                      name='accountHolderName'
                      label="Account Holder Name"
                      placeholder="Enter Account Holder Name"
                      requiredField
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='textfield'
                      name='accountNumber'
                      label="Account Number"
                      placeholder="Enter Account Number"
                      requiredField
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='textfield'
                      name='bankName'
                      label="Bank Name"
                      placeholder="Enter Bank Name"
                      requiredField
                    />
                  </div>


                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='autocomplete'
                      label="Country"
                      name="countryId"
                      placeholder="Select Country"
                      requiredField={true}
                      options={countryList}
                      keyfield="name"
                      valuefield="countryIdentifier"
                    />
                  </div>


                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl
                      control="autocomplete"
                      name="currency"
                      label="Currency"
                      placeholder="currencey"
                      requiredField
                      options={formattedCurrencyList}
                      keyfield="displayName"
                      valuefield="code"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl
                      control='textfield'
                      name="branchName"
                      label="Branch name"
                      placeholder="Enter Branch Name"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='textfield'
                      name="swiftCode"
                      label="SWIFT / BIC Code"
                      placeholder="Enter SWIFT Code"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='textfield'
                      name="iban"
                      label="IBAN"
                      placeholder="Enter IBAN"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='textfield'
                      name="routingNo"
                      label="Routing No / ABA No"
                      placeholder="Enter Routing No"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 position-relative">
                    <FormikControl control='textfield'
                      name="type"
                      label="Type"
                      placeholder="Enter Type"
                    />
                  </div>

                  <div className='col-12 d-flex justify-content-end'>
                    <FormikControl control='button' className="btn btn-submit" color="primary" label={values.bankId === '' ? "Save" : "Update"} type="submit" disabled={!dirty || !isValid} />&nbsp;&nbsp;
                    {userRole === msgTypes.USER_TYPE.ADMIN && (
                      <FormikControl control='button' className="btn btn-cancel" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                    )}
                  </div>
                </div>
              </div>

            </Form>
            )
          }
        }
      </Formik>
    </>
  )



}
export default CreateMemberBank;


